// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import * as bootstrap from "bootstrap"
import "./custom/dashboard_charts"

window.bootstrap = bootstrap;


// Method 1: Using turbo:load event
document.addEventListener("turbo:load", function() {
    setupNavbarShadow();

    if (document.getElementById('video-showcase')) {
        import('./pages/index.js')
            .then(pageModule => {
            if (pageModule.default && typeof pageModule.default === 'function') {
                pageModule.default();
            }
            })
            .catch(error => console.error("Failed to load video-showcase.js:", error));
    }

    const catalogPage = document.getElementById('catalog-page');
    if (catalogPage) {
        const moduleName = "catalog";
        import(`./pages/${moduleName}.js`)
            .then(module => {
            if (module.default && typeof module.default === 'function') {
                module.default();
            }
            })
            .catch(err => console.error(`Error loading ${moduleName}.js:`, err));
    }    

  });

// Method 2: As a backup, also listen for DOMContentLoaded
document.addEventListener("DOMContentLoaded", function() {
    setupNavbarShadow();
});

// Separate the functionality into its own function
function setupNavbarShadow() {
    const navbar = document.getElementById('navbar');

    if (navbar) {
        // First, check if we're already scrolled down when loading a page
        if (window.scrollY > 10) {
        navbar.classList.add('shadow-on-scroll');
        }
        
        // Then set up the scroll listener
        const handleScroll = function() {
        if (window.scrollY > 10) {
            navbar.classList.add('shadow-on-scroll');
        } else {
            navbar.classList.remove('shadow-on-scroll');
        }
        };
        
        // Remove any existing event listeners to prevent duplicates
        window.removeEventListener('scroll', handleScroll);
        
        // Add the new event listener
        window.addEventListener('scroll', handleScroll);
    }
}
